<div class="wrapper">
    <!-- fixed navbar -->
    <app-navbar></app-navbar>
    <div class="sidebar" data-color="white" data-background-color="grey">
        <app-sidebar></app-sidebar>
         <div class="sidebar-background"></div>
    </div>
    <div class="main-panel">
        <app-breadcrumb></app-breadcrumb>
        <router-outlet></router-outlet>
        <div *ngIf="isMaps('maps')">
            <app-footer></app-footer>
        </div>
    </div>
</div>
